import { render, staticRenderFns } from "./chatInput.vue?vue&type=template&id=4f659970&"
import script from "./chatInput.vue?vue&type=script&lang=js&"
export * from "./chatInput.vue?vue&type=script&lang=js&"
import style0 from "./chatInput.vue?vue&type=style&index=0&id=4f659970&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports